import { Component } from "@/types"
import { ButtonLink } from "@/ui/atoms/controls/ButtonLink"
import { Grid } from "@/ui/atoms/layout/Grid"
import { Stack } from "@/ui/atoms/layout/Stack"
import { Image } from "@/ui/atoms/media/Image"
import { ReactVideoPlayerNoSSR } from "@/ui/atoms/media/ReactVideoPlayer"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { Title } from "@/ui/atoms/type/Title"
import { MarketingSection } from "@/ui/blocks/layout/MarketingSection"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "heroSection"

const VIDEO_URL = "https://stream.mux.com/D3BadPx005iere3FsHIjAo00tnairHfahC02e5Uhs8eEPo.m3u8"
const VIDEO_POSTER_URL = "/content/marketing/hero-video-poster.jpg"

export const presets = {}

export interface Props extends Component {}

export function HeroSection({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(`text-text`, className)} data-test={testId}>
      <MarketingSection removeXPadding>
        <Grid className="gap-8">
          {/* Content */}
          <Stack className="col-span-12 md:col-span-5 gap-4 text-center items-center md:text-left md:items-start">
            <Title size="xl" className="lg:text-[48px]">
              Master the fundamentals of cybersecurity
            </Title>
            <BodyText size="lg" className="text-text-secondary">
              The SANS Foundations course helps businesses, government bodies and academic
              institutions recruit, train and re-skill cybersecurity professionals.
            </BodyText>
            <ButtonLink
              href="https://www.sans.org/about/contact/sales"
              label="Get in touch"
              variant="primary"
              className="max-w-full sm:max-w-fit px-8"
            ></ButtonLink>
          </Stack>

          {/* Video */}
          <Stack className="col-span-12 md:col-span-7">
            <div className="rounded-lg overflow-hidden aspect-video bg-gray-800 grid-single-cell grid place-items-center grid-single-cell">
              <Image
                src={VIDEO_POSTER_URL}
                alt="Video Poster"
                className="w-full h-full object-cover"
                width={616}
                height={346}
                priority
              />
              <ReactVideoPlayerNoSSR url={VIDEO_URL} poster={VIDEO_POSTER_URL} />
            </div>
          </Stack>
        </Grid>
      </MarketingSection>
    </div>
  )
}
